interface SVGRProps {
    title?: string;
    titleId?: string;
}

const ICalendarIcon: React.VFC<React.SVGProps<SVGSVGElement> & SVGRProps> = ({
    title,
    titleId,
    ...props
}) => {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 42 42"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <rect width={42} height={42} rx={9} fill="#F9F9F9" />
            <path
                d="M1.174 4.54C.22 6.21.036 8.337 0 12h41.983c-.036-3.664-.222-5.79-1.174-7.46a9 9 0 00-3.358-3.358C35.377 0 32.602 0 27.05 0h-12.12C9.381 0 6.605 0 4.532 1.182a9 9 0 00-3.358 3.359z"
                fill="#D96052"
            />
            <path
                d="M15.023 9.098c1.223 0 1.93-.692 1.93-1.88V3.364h-1.18v3.844c0 .57-.265.871-.761.871-.465 0-.723-.305-.742-.742l-.004-.024H13.12l.004.036c.027 1.058.734 1.75 1.898 1.75zM20.3 9.098c1.454 0 2.36-.84 2.36-2.09V3.363h-1.18v3.54c0 .73-.421 1.195-1.18 1.195-.757 0-1.183-.465-1.183-1.196V3.363h-1.18v3.645c0 1.254.918 2.09 2.364 2.09zM23.602 9h3.644v-.973h-2.465V3.363h-1.18V9z"
                fill="#F6F5F5"
            />
            <path
                d="M14.157 35h2.21V16.68h-2.235l-4.875 3.505v2.297l4.85-3.377h.05V35zM22.066 35h2.4l8.15-16.2v-2.12H20.492v2.032h9.864v.05L22.066 35z"
                fill="#2C2C2C"
            />
        </svg>
    );
};

export default ICalendarIcon;
